export enum SortDirection {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}
